import { render, staticRenderFns } from "./LifeLicenseApproval.vue?vue&type=template&id=07cc576b&scoped=true"
import script from "./LifeLicenseApproval.vue?vue&type=script&lang=js"
export * from "./LifeLicenseApproval.vue?vue&type=script&lang=js"
import style0 from "./LifeLicenseApproval.vue?vue&type=style&index=0&id=07cc576b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc576b",
  null
  
)

export default component.exports